const React = require('react');
const Immutable = require('seamless-immutable');
require('./handle-input.scss');

import BaseComponent from '../../helper/BaseComponent';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import dishHelper from '../../helper/dish-helper.js';
import { MaxOrderedDishCount } from '../../helper/const';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import buttonMessages from './../../intl/messages/button';
import errorMessages from './../../intl/messages/error-message';

const { isSingleDishWithoutProps, getDishPrice } = dishHelper;
const Toast = require('../mui/toast.jsx');

class HandleInput extends BaseComponent {
  static propTypes = {
    cancelHandleInput: React.PropTypes.func,
    dishItem: React.PropTypes.object,
    onOrderBtnTap: React.PropTypes.func,
    count: React.PropTypes.number,
  }

  static defaultProps = {
    numTotal: MaxOrderedDishCount,
  }

  constructor(props) {
    super(props);

    this.state = {
      dishNum: this.props.count,
      keyBoardStatus: true,
      errorMessage: '',
    };

    this.bind(
      'addNewDishNum',
      'deleteDishNum',
      'confirmDishNum',
      'clearErrorMsg',
      'handleInputRules',
    );
  }

  componentWillReceiveProps(nextProps) {
    const { display, count } = nextProps;

    if (display) {
      this.setState({
        dishNum: count,
        keyBoardStatus: true,
      });
    }
  }

  // 键盘输入控制
  addNewDishNum(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    const { keyBoardStatus, dishNum } = this.state;
    const { numTotal } = this.props;
    const text = evt.target.innerHTML;

    const newDishNum = keyBoardStatus ? text : Number(dishNum + text);
        // 最多可售份数
    if (Number(newDishNum) > numTotal) {
      this.setState({
        errorMessage: formatMessage(errorMessages.onlyStockLeft, { numTotal }),
        keyBoardStatus: true,
        dishNum: numTotal,
      });

      return {
        status: false,
        dishChange: numTotal,
      };
    }

    if (Number(newDishNum) > MaxOrderedDishCount) {
      this.setState({
        errorMessage: formatMessage(errorMessages.enteredUpTo5digits),
      });

      return false;
    }

    this.setState({
      dishNum: Number(newDishNum),
      keyBoardStatus: false,
    });

    return true;
  }

  deleteDishNum(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    const dishNum = String(this.state.dishNum);
    const text = dishNum.substr(0, dishNum.length - 1);

    this.setState({
      dishNum: Number(text),
    });
  }

  confirmDishNum(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    const { onOrderBtnTap, count } = this.props;
    const { dishNum } = this.state;

    const { status } = this.handleInputRules(dishNum);

    if (status) {
      const increment = dishNum - count;

      if (increment) {
        onOrderBtnTap(count + increment, increment);
      }

      this.cancelHandleInput();
    }
  }

  cancelHandleInput(evt) {
    if (evt) {
      evt.preventDefault();
    }

    document.getElementById('handleInputDOM').style.display = 'none';
  }

  getOrderCounter(dishItem) { // 根据菜品类型不同获取菜品数量
    let orderCount = 0;

    const { order, dishIngredientInfos } = dishItem;

    if (isSingleDishWithoutProps(dishItem)) { // 单菜品
      orderCount = order;
    } else { // 多规格和选子菜
      if (dishIngredientInfos.length === 0) { // 有多规格的情况
        orderCount = order;
      } else {
        orderCount = order[0].count; // 每次显示的是第一条数据的count
      }
    }

    return orderCount;
  }

  getOrderPrice_(dishItem) {
    const dishTemp = (Immutable.from(dishItem)).setIn(['order', '0', 'count'], 1);

    if (isSingleDishWithoutProps(dishItem)) {
      return dishItem.marketPrice;
    }

    return (getDishPrice(dishTemp));
  }

  clearErrorMsg() {
    this.setState({
      errorMessage: '',
    });
  }

  getRemaining(numTotal, dishIncreaseUnit, stepNum) {
    const Remaining = (numTotal - dishIncreaseUnit) / (stepNum || 1);

    return Math.floor(Remaining) * stepNum + dishIncreaseUnit;
  }

  handleInputRules(dishCount) {
    const { dishItem, numTotal } = this.props;
    const { stepNum, dishIncreaseUnit } = dishItem;
    let rules = { status: true };

    if (dishIncreaseUnit && dishCount < dishIncreaseUnit && (this.props.flag || (!this.props.flag && dishCount !== 0))) { // 起卖份数
      this.setState({
        errorMessage: formatMessage(errorMessages.notLowerThanDishIncreaseUnit, { dishIncreaseUnit }),
        keyBoardStatus: true,
        dishNum: dishIncreaseUnit,
      });

      rules = {
        status: false,
        dishChange: dishIncreaseUnit,
      };

      return rules;
    }

    if (stepNum && dishCount !== 0) {
      const temp = (dishCount - (dishIncreaseUnit || 0)) / stepNum;

      if (!Number.isInteger(temp)) {
        rules.status = false;
        const fixedNum = Math.ceil(temp) * stepNum + dishIncreaseUnit;

        if (fixedNum <= numTotal) {
          rules.dishChange = fixedNum;
        } else {
          rules.dishChange = Math.floor((numTotal - dishIncreaseUnit) / stepNum) * stepNum + dishIncreaseUnit;
        }

        this.setState({
          errorMessage: formatMessage(errorMessages.notLowerThanDishIncreaseUnit, { dishIncreaseUnit: dishIncreaseUnit || 1, stepNum, dishChange: rules.dishChange }),
          keyBoardStatus: true,
          dishNum: rules.dishChange,
        });

        return rules;
      }
    }

    return rules;
  }

  render() {
    const { dishItem } = this.props;
    const { dishNum, errorMessage } = this.state;
    const numArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

    const numItem = numArr.map((item, index) => (<button key={index} onTouchTap={evt => { this.addNewDishNum(evt); }}>{item}</button>));


    return (
      <div className="handle-input" onTouchTap={evt => { evt.preventDefault(); this.cancelHandleInput(evt); }}>

        <div className="handle-input-box" onTouchTap={evt => { evt.preventDefault(); evt.stopPropagation(); }}>
          <div className="handle-input-dish">
            <div className="dish-detail">
              <span className="dish-detail-img"><HttpsProtocolImage src={dishItem.largeImgList[0] || dishItem.smallImgUrl} /></span>
              <div className="dish-detail-info">
                <span className="dishInfo">{dishItem.name}</span>
                <span className="price">{this.getOrderPrice_(dishItem)}</span>
              </div>
              <div className="dish-detail-count">
                <span
                  className="handle-close"
                  onTouchTap={evt => this.cancelHandleInput(evt)}
                ></span>
                <span className="">
                  <i>{String(dishNum)}</i>
                  {dishItem.unitName !== '份' ? '' + dishItem.unitName : '份'}
                </span>
              </div>
            </div>
          </div>
          <div className="handle-input-bord">
            <div className="bord-num">
              {numItem}
            </div>
            <div className="bord-event">
              <button onTouchTap={evt => { this.deleteDishNum(evt); }} ></button>
              <button onTouchTap={evt => { this.confirmDishNum(evt); }}><FormattedMessage {...buttonMessages.finish} /></button>
            </div>
          </div>
        </div>
        {errorMessage ?
          <Toast errorMessage={errorMessage} clearErrorMsg={this.clearErrorMsg} timeout={2000} />
          :
          false
        }
      </div>
    );
  }
}

export default HandleInput;



// WEBPACK FOOTER //
// ./src/component/mui/handle-input.jsx